import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Mail, Shield } from 'lucide-react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { Container } from '../components/layout/Container';

export function RefundPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />

      <main className="flex-1 py-12 pt-24">
        <Container size="md">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>

          <h1 className="text-3xl font-bold text-gray-900 mb-2">About the Free Compliance Snapshot</h1>
          <p className="text-gray-500 mb-8">Last updated: March 2026</p>

          <div className="prose prose-gray max-w-none">
            <p className="text-lg text-gray-700 mb-6">
              The Compliance Risk Snapshot is a free assessment for home care agencies.
            </p>

            <div className="bg-teal-50 border border-teal-200 rounded-lg p-6 my-6">
              <h2 className="text-lg font-semibold text-teal-800 mb-3 flex items-center gap-2">
                <Shield className="w-5 h-5" />
                What You Get
              </h2>
              <p className="text-teal-800 ml-7 mb-3">
                A state-specific compliance assessment covering licensing, background screening,
                training requirements, and documentation — with a detailed PDF report delivered
                within 48 hours.
              </p>
              <p className="text-teal-700 ml-7 text-sm italic">
                No payment required. No hidden fees.
              </p>
            </div>

            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 my-8">
              <h3 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                <Mail className="w-5 h-5" style={{ color: '#009688' }} />
                Contact
              </h3>
              <p className="text-gray-700 mb-2">
                <a href="mailto:support@getasili.com" className="hover:underline" style={{ color: '#009688' }}>
                  support@getasili.com
                </a>
              </p>
              <p className="text-gray-600 text-sm">
                Questions? We're happy to help.
              </p>
            </div>
          </div>
        </Container>
      </main>

      <Footer />
    </div>
  );
}
